var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c("b", [_vm._v("External Ids")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "headerBtn",
                  attrs: {
                    variant: "outline-primary",
                    disabled: !_vm.isAllowedToCreateOrEditPerson
                  },
                  on: { click: _vm.toggleModal }
                },
                [_vm._v("Add Ext Id")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.personExternalIds.length > 0
            ? _c(
                "div",
                _vm._l(_vm.personExternalIds, function(extId) {
                  return _c(
                    "b-list-group",
                    { key: extId.id, attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._.get(extId, "externalId", "Unknown")
                              ) +
                                " (" +
                                _vm._s(
                                  _vm._.get(extId, "eorganization.title")
                                ) +
                                ")"
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.personExternalIds.length === 0
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [_vm._v("No External Ids")])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Add External Id",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            size: "lg",
            visible: _vm.modalVisible,
            centered: ""
          },
          on: { hide: _vm.resetResponse, ok: _vm.add },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function() {
                return [_c("h4", [_vm._v("X")])]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary", size: "sm" },
                      on: { click: _vm.toggleModal }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.add }
                    },
                    [_vm._v("\n          Submit\n        ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                { attrs: { label: "External Id", "label-for": "extid" } },
                [
                  _c("b-form-input", {
                    attrs: { size: "lg", type: "text", name: "extid" },
                    model: {
                      value: _vm.form.externalId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "externalId", $$v)
                      },
                      expression: "form.externalId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              attrs: {
                dismissible: "",
                fade: "",
                show: !_vm._.isEmpty(_vm.createExternalIdResponse.body),
                variant: _vm.createExternalIdResponse.ok ? "success" : "danger"
              }
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.apiResponseMessage(_vm.createExternalIdResponse)
                  )
                }
              })
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c9be5a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c9be5a4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Person/PersonExternalIds.vue
// module id = 1602
// module chunks = 0